<template>
    <div id="app">
      	<router-view @logged="logged" />
    </div>
</template>

<script>
import Vue from 'vue'
import API from '@/fetch/api';
import * as access from "@/config/access";
import { checkStatus } from '@/common/util/constans' 
import { GetInfo } from '@/fetch/com'
import { routeList } from '@/router/routeList'

export default {
    data(){
        return {
            checkStatus,
            token: GetInfo('token') || '',
            projectId: GetInfo('projectId') || '',
            userParks: []
        }
    },
    created(){
        /* if(!this.token){
            this.$router.push({ name: 'login' });
            return;
        } */
        if(this.token) {
            !this.projectId && this.getUserPark(),
            this.queryAuth()
        }
    },
    methods: {
        logged(){ // 登录完成
            let vm = this;
            Promise.all([
                this.getUserPark(),
                this.queryAuth()
            ]).then(vm.queryUserInfo)
        },
        queryUserInfo(){ // 查询用户基本信息 
            let vm = this;
            API.http({ url: '/merchant/audit_info', type: 'post'}).then(res => {
                if (res.code == 200) {
                    let userInfo = res.data;
                    /* 
                        // 老用户均是跳转到index，存储当前的步骤
                        // 新用户 跳转到 registerInfo，存储当前步骤
                        从消息可以跳转到审核通过的界面
                    */
                    let url = userInfo.newFlag ? 'registerInfo' : 'index';
                    
                    // 存储必须信息
                    access.session('checkStatusC', vm.checkStatus[String(userInfo.checkStatus)]); //审核状态名称
                    access.session('checkStatus', userInfo.checkStatus); //审核状态
                    access.session('companyName', userInfo.companyName); //公司名称
                    access.session('ystRegisterStep', userInfo.ystRegisterStep); 
                    access.session('newFlag', userInfo.newFlag); //是否为新用户
                    vm.$router.replace({name: url})
                    return;
                }
                vm.$showAlert(res.message || res.error ||  '查询用户信息失败，请重试', 'error');
            }).catch((res)=>{
                vm.$showAlert(res.message || res.error ||  '查询用户信息失败，请重试', 'error')
            })
        },
        // 获取用户选择过的园区
        getUserPark(){
            let vm = this;
            return new Promise((resolve, reject) => {
                API.http({ url: '/merchant/users/park/list', type: 'post'}).then(res => {
                    if(res.code == 200){
                        vm.userParks = res.data || [];
                        if(vm.userParks.length){
                            access.session('projectId', vm.userParks[0].parkId);
                            access.session('projectName', vm.userParks[0].parkName);
                            access.session('city', vm.userParks[0].city);
                        } 
                        access.session('userParks', vm.userParks);
                        resolve();
                        return;
                    }
                    reject();
                }).catch((res)=>{
                    reject();
                })
            })
        },
        // 查询菜单权限 
        queryAuth(resolve){
            let vm = this;
            return new Promise((resolve, reject) => {
                API.http({ url: '/merchant/users/own_permission', type: 'post'}).then(res => {
                    if (res.code == 200) {
                        vm.auth = res.data;
                        vm.auth.push('merchant_editPwd_list');
                        // 注册全局方法，如果有权限则返回 true
                        Vue.prototype.$_auth = (meun)=> {
                            if(vm.auth.indexOf(`merchant_${meun}`) == -1){
                                return false;
                            }
                            return true;
                        }
                        // 查询现有路由是否有权限访问
                        
                        let extendRouter = [];
                        let defaultUrl = '';
                        for(let i = 0; i < routeList.length; i++){
                            let item = routeList[i];
                            if(vm.auth.indexOf(`merchant_${item.auth}`) == -1 && item.name != 'index') continue;
                            let route = {};
                            for(let key in item){
                                if(key != 'children'){
                                    route[key] = item[key];
                                }
                            }
                            if(item.children){
                                route.children = [];
                                item.children.forEach((child, i)=>{
                                    // 系统设置和商品管理的权限
                                    /* 
                                    系统设置  user_list、role_list、editPwd_list、info_all
                                    */
                                    // if()
                                    if(vm.auth.indexOf(`merchant_${child.auth}`) != -1) {
                                        if(!defaultUrl && child.path != '/standardPage') defaultUrl = child.path;
                                        route.children.push(child);
                                    }
                                })
                            }
                            extendRouter.push(route);
                        }
                        let childRouter = extendRouter[0].children;
                        childRouter.map(item=>{
                            return item.beforeEnter = function(to, from, next){
                                if(vm.auth.indexOf(`merchant_${item.auth}`) != -1){
                                    next()
                                }else{
                                    next('/401')
                                }
                            }
                        })
                        extendRouter[0].children = childRouter;
                        extendRouter[0].redirect = defaultUrl;
                        vm.$router.addRoutes(extendRouter);
                        resolve();
                        return;
                    }
                    access.session('token','');
                    vm.$showAlert('账号访问受限，请联系系统管理员！', 'error');
                    vm.$router.replace({ name: 'login' });
                    reject()
                }).catch((res)=>{
                    access.session('token','');
                    vm.$showAlert('账号访问受限，请联系系统管理员！', 'error');
                    vm.$router.replace({ name: 'login' });
                    reject()
                })
            })
        },
    }
}
</script>

